import { useEffect, useRef } from "react";
import { Actions } from "../reducers/Booking";

const useSessionTimeout = (
  state,
  dispatch,
  sessionStartTimestampField,
  timeoutMinutes
) => {
  const handler = useRef(null);

  useEffect(() => {
    if (handler) {
      clearTimeout(handler.current);
      handler.current = null;
    }

    const startVal = (state || {})[sessionStartTimestampField];
    if (startVal) {
      const durationInMillis = Date.now() - startVal;
      const durationInMinutes = durationInMillis / 1000 / 60;
      const durationLeftInMillis =
        startVal + timeoutMinutes * 1000 * 60 - Date.now();

      if (durationInMinutes >= timeoutMinutes) {
        dispatch({ type: Actions.Timeout });
      } else {
        handler.current = setTimeout(() => {
          dispatch({ type: Actions.Timeout });
        }, durationLeftInMillis);
      }
    }
  }, [state, sessionStartTimestampField, timeoutMinutes, dispatch]);

  return;
};

export default useSessionTimeout;
